/* Pouchhut — collapsible accordions (+/- toggle) for the
   Specifications block and the "You may also like" recommendations.
   Styled by ph-product.css. Open on desktop, collapsed on phone. */
(function () {
  function toArray(list) { return Array.prototype.slice.call(list); }

  function isDesktop() {
    return window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
  }

  function makeAccordion(title, extraClass) {
    var details = document.createElement('details');
    details.className = 'ph-spec-accordion' + (extraClass ? ' ' + extraClass : '');
    var summary = document.createElement('summary');
    summary.className = 'ph-spec-accordion__summary';
    summary.textContent = title;
    var body = document.createElement('div');
    body.className = 'ph-spec-accordion__body' + (extraClass ? ' ' + extraClass + '__body' : '');
    details.appendChild(summary);
    details.appendChild(body);
    if (isDesktop()) details.open = true;
    return { details: details, body: body };
  }

  function buildSpecs(scope) {
    toArray(scope.querySelectorAll('.product-specifications')).forEach(function (el) {
      if (el.getAttribute('data-ph-accordion')) return;
      el.setAttribute('data-ph-accordion', '1');
      var heading = el.querySelector('h2');
      var title = heading && heading.textContent ? heading.textContent.trim() : 'Specifications';
      var acc = makeAccordion(title);
      toArray(el.childNodes).forEach(function (node) {
        if (node === heading) return;
        acc.body.appendChild(node);
      });
      if (heading && heading.parentNode) heading.parentNode.removeChild(heading);
      el.appendChild(acc.details);
    });
  }

  function buildRecs(scope) {
    toArray(scope.querySelectorAll('.product-recommendations')).forEach(function (rec) {
      if (rec.getAttribute('data-ph-accordion')) return;
      var section = rec.querySelector('.section-resource-list') || rec.querySelector('.section');
      if (!section) return;
      if (!rec.querySelector('.product-card')) return; /* wait for real cards */
      var grids = toArray(section.querySelectorAll('.resource-list'));
      if (!grids.length) return;
      var headingWrap = section.querySelector('.section-resource-list__content');
      var title = headingWrap && headingWrap.textContent ? headingWrap.textContent.trim() : 'You may also like';
      rec.setAttribute('data-ph-accordion', '1');
      var acc = makeAccordion(title, 'ph-rec-accordion');
      grids.forEach(function (g) { acc.body.appendChild(g); });
      if (headingWrap && headingWrap.parentNode) {
        section.insertBefore(acc.details, headingWrap);
        headingWrap.parentNode.removeChild(headingWrap);
      } else {
        section.appendChild(acc.details);
      }
    });
  }

  function build(root) {
    var scope = root && root.querySelectorAll ? root : document;
    buildSpecs(scope);
    buildRecs(scope);
  }

  function init() { build(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  setTimeout(init, 800);
  setTimeout(init, 2000);
  document.addEventListener('shopify:section:load', function (e) {
    build(e.target || document);
  });
})();
